import { FormControl, FormGroup } from "@angular/forms";
import { AssessmentPdfGenerator } from "src/app/patients/dashboard-page/assessments-history-tab/assessment-to-pdf";

export const noString = 'N/A'; // the default string to use if no value is provided for string variables

export type ControlsOf<T> = {
  [K in keyof T]: FormControl<T[K] | null>;
};

export interface AssessmentHelpers<T, Extra = void> {
  createFormGroup: (assessment?: T) => FormGroup<ControlsOf<T>>;
  toPDF: (pdf: AssessmentPdfGenerator, assessment: T, extra: Extra) => void;
  formToObject: (fg: FormGroup<ControlsOf<T>>) => T;
  initialState: T;
}